import AccessForm, { FormState } from "@common-components/access-form/access-form";
import FormPatial from "@common-components/access-form/form-patial";
import {
    CLEAR_BRAND_LOGIN_ILLUSTRATION,
    CLEAR_BRAND_SIGNUP_ILLUSTRATION,
} from "@common-config/clear-brand";
import { isClearFlow } from "@common/utils/clear-flow";
import { openCookieSettings } from "@common/components/cookie-consent/cookie-consent-banner";
import { namespace } from "@common-config/constants";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import classes from './login-view.module.scss';

export interface LoginViewProps {
    initialState?: FormState
}

export interface LoginViewState {
    loading: boolean;
}

export const LoginView = ({ initialState }: LoginViewProps) => {
    const { t } = useTranslation(namespace);
    // Follow the live form state (login -> "forgot password" swaps forms in place).
    const formState = useAppSelector((state) => state.MainReducer.formState);
    const currentState = formState === "SIGNUP" ? FormState.Signup
        : formState === "RESET_PASSWORD" ? FormState.ForgotPassword
        : formState ? FormState.Login
        : initialState;

    // The clear flow is a separate product: it must not show the Blueticks
    // illustrations. Its own artwork lives in clear-brand.
    const clearImagePath = currentState === FormState.Signup
        ? CLEAR_BRAND_SIGNUP_ILLUSTRATION
        : CLEAR_BRAND_LOGIN_ILLUSTRATION;

    // Use appropriate image based on form state
    const imagePath = isClearFlow()
        ? clearImagePath
        : currentState === FormState.Signup
        ? "/img/signup-illustrator.png"
        : currentState === FormState.ForgotPassword
        ? "/img/forgot_password_illustrator.png"
        : "/img/login-illustrator.png";

    return (
        <div className={classes.loginViewContainer}>
            <FormPatial imagePath={imagePath}>
                <AccessForm initialState={initialState} />
            </FormPatial>
            {/* Logged-out visitors have no account menu; this keeps cookie choices reachable (spec 23 section 7). */}
            <div style={{ textAlign: "center", padding: "8px 16px", fontSize: 12 }}>
                <button
                    type="button"
                    onClick={openCookieSettings}
                    data-testid="login-cookie-settings"
                    style={{ background: "none", border: "none", padding: 0, color: "inherit", textDecoration: "underline", cursor: "pointer", font: "inherit" }}
                >
                    {t('cookieConsent.settingsMenu', { defaultValue: 'Cookie settings' })}
                </button>
            </div>
        </div>
    );
}

export default LoginView;
